<template>
    <div class="syncResults text-center">
        <h1 v-if="user.isNew"
            class="mb-0">
            Welcome To Who Deleted Me, {{ name }}.
        </h1>
        <h1 v-else
            class="mb-0">
            Welcome Back, {{ name }}.
        </h1>

        <h2 v-if="hasChanges">
            <MissingCountBtn v-if="missingCount"
                             :count="missingCount" />
<!--            <DeactivatedCountBtn v-if="deactivatedCount"-->
<!--                                 :count="deactivatedCount" />-->
            <NewCountBtn v-if="newCount"
                         :count="newCount" />
        </h2>
        <h2 v-else>
            Nobody has deleted you since you were last here.
        </h2>

        <p>
            We've saved the {{ fetchedFriendsCount }} {{ plural('friend', fetchedFriendsCount ) }} you have.
            Don't forget to check back often to see if anybody goes missing.
        </p>

        <div class="actions mt-1">
            <template v-if="hasChanges">
                <a class="recheckButton btn btn-info"
                   href="/sync"><i class="glyphicon glyphicon-refresh"></i> Check Again</a>
                &nbsp;
                <a class="nextButton btn btn-blue"
                   href="/friends"><i class="glyphicon glyphicon-chevron-right"></i> Let's Go See Who</a>
            </template>
            <template v-else>
                <a class="recheckButton btn btn-info"
                   href="/sync"><i class="glyphicon glyphicon-refresh"></i> Check Again</a>
                &nbsp;
                <a class="nextButton btn btn-blue"
                   href="/friends/deleted-me"><i class="glyphicon glyphicon-chevron-right"></i> See Who Deleted You Previously</a>
            </template>
        </div>
    </div>
</template>

<script>
// import DeactivatedCountBtn from './DeactivatedCountBtn';
import MissingCountBtn from './MissingCountBtn';
import NewCountBtn from './NewCountBtn';
import { getUserName } from 'wdm-common/Users';

export default {
    components: {
        // DeactivatedCountBtn,
        NewCountBtn,
        MissingCountBtn,
    },

    props: {
        user: {
            type: Object,
            required: true,
        },

        friendCounts: {
            type: Object,
            required: true,
        },

        syncResults: {
            type: Object,
            required: true,
        },
    },

    computed: {
        name() {
            return getUserName(this.user);
        },

        missingCount() {
            return this.friendCounts.unseenDeletedFriends;
        },

        deactivatedCount() {
            return this.friendCounts.unseenDeactivatedFriends;
        },

        newCount() {
            return this.friendCounts.unseenNewFriends;
        },

        fetchedFriendsCount() {
            return this.syncResults.fetchedActiveFriends + this.syncResults.fetchedDeactivatedFriends;
        },

        hasChanges() {
            return this.missingCount > 0
                || this.deactivatedCount > 0
                || this.newCount > 0;
        },
    },
};
</script>
